import { environment } from 'src/environments/environment';
import { httpInterceptorsProviders } from './http-interceptors/index';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { } from '@angular/google-maps'
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { LoginComponent } from './login/login.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { ConfiguracaoComponent } from './configuracao/configuracao.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { CriarUsuarioComponent } from './usuarios/criar-usuario/criar-usuario.component';
import { AtualizarUsuarioComponent } from './usuarios/atualizar-usuario/atualizar-usuario.component';
import { GruposComponent } from './grupos/grupos.component';
import { CriarGrupoComponent } from './grupos/criar-grupo/criar-grupo.component';
import { AtualizarGrupoComponent } from './grupos/atualizar-grupo/atualizar-grupo.component';
import { PermissaoComponent } from './permissao/permissao.component';
import { CriarPermissaoComponent } from './permissao/criar-permissao/criar-permissao.component';
import { AtualizarPermissaoComponent } from './permissao/atualizar-permissao/atualizar-permissao.component';
import { ClientesComponent } from './clientes/clientes.component';
import { CriarClienteComponent } from './clientes/criar-cliente/criar-cliente.component';
import { AtualizarClienteComponent } from './clientes/atualizar-cliente/atualizar-cliente.component';
import { ProdutosComponent } from './produtos/produtos.component';
import { CriarProdutoComponent } from './produtos/criar-produto/criar-produto.component';
import { AtualizarProdutoComponent } from './produtos/atualizar-produto/atualizar-produto.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { FooterComponent } from './footer/footer.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AtualizarSenhaComponent } from './usuarios/atualizar-senha/atualizar-senha.component';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { CookieService } from 'ngx-cookie-service';
import { MatSelectModule } from '@angular/material/select';
import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';
import { SolicitarNovaSenhaComponent } from './solicitar-nova-senha/solicitar-nova-senha.component';
import { RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { AlertaSessaoComponent } from './alerta-sessao/alerta-sessao.component';
import { RedirectComponent } from './redirect/redirect.component';
import { SenhaPrimeiroAcessoComponent } from './senha-primeiro-acesso/senha-primeiro-acesso.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContratosComponent } from './contratos/contratos.component';
import { CriarContratoComponent } from './contratos/criar-contrato/criar-contrato.component';
import { AtualizarContratoComponent } from './contratos/atualizar-contrato/atualizar-contrato.component';
import { DialogComponent } from './home/dialog/dialog.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DialogContratoComponent } from './contratos/dialog-contrato/dialog-contrato.component';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { PesquisaCadastrarComponent } from './pesquisa/pesquisa-cadastrar/pesquisa-cadastrar.component';
import { DialogEscolherGrupoComponent } from './pesquisa/dialog-escolher-grupo/dialog-escolher-grupo.component';
import { AgrupamentosComponent } from './agrupamentos/agrupamentos.component';
import { CriarAgrupamentosComponent } from './agrupamentos/criar-agrupamentos/criar-agrupamentos.component';
import { ListaUsuariosComponent } from './agrupamentos/lista-usuarios/lista-usuarios.component';
import { ListaClientesComponent } from './agrupamentos/lista-clientes/lista-clientes.component';
import { AtualizarAgrupamentoComponent } from './agrupamentos/atualizar-agrupamento/atualizar-agrupamento.component';
import { LicencaComponent } from './licenca/licenca.component';
import { CadastrarLicencaComponent } from './licenca/cadastrar-licenca/cadastrar-licenca.component';
import { AdquirirLicencaComponent } from './licenca/adquirir-licenca/adquirir-licenca.component';
import { AlterarLicencaAdquiridaComponent } from './licenca/alterar-licenca-adquirida/alterar-licenca-adquirida.component';
import { EscolherUsuarioEnviarTokenComponent } from './licenca/escolher-usuario-enviar-token/escolher-usuario-enviar-token.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DialogAcessosPremocenterComponent } from './relatorios/dialog-acessos-premocenter/dialog-acessos-premocenter.component';
import { AgviewsConnectComponent } from './agviews-connect/agviews-connect.component';
import { AgviewsConnectAtualizarComponent } from './agviews-connect/agviews-connect-atualizar/agviews-connect-atualizar.component';
import { SsoCallbackComponent } from './sso-callback/sso-callback.component';
import { ShapesComponent } from './shapes/shapes.component';
import { CadastrarShapeComponent } from './shapes/cadastrar-shape/cadastrar-shape.component';
import { MiniMapaGeojsonComponent } from './shapes/cadastrar-shape/mini-mapa-geojson/mini-mapa-geojson.component';
import { SelectBuscaClienteComponent } from './select-busca-cliente/select-busca-cliente.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTabsModule } from '@angular/material/tabs';
import { MapaShapeDialogComponent } from './mapa-shape-dialog/mapa-shape-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    ConfiguracaoComponent,
    UsuariosComponent,
    CriarUsuarioComponent,
    AtualizarUsuarioComponent,
    GruposComponent,
    CriarGrupoComponent,
    AtualizarGrupoComponent,
    PermissaoComponent,
    CriarPermissaoComponent,
    AtualizarPermissaoComponent,
    ClientesComponent,
    CriarClienteComponent,
    AtualizarClienteComponent,
    ProdutosComponent,
    CriarProdutoComponent,
    AtualizarProdutoComponent,
    FooterComponent,
    AtualizarSenhaComponent,
    RecuperarSenhaComponent,
    SolicitarNovaSenhaComponent,
    AlertaSessaoComponent,
    RedirectComponent,
    SenhaPrimeiroAcessoComponent,
    ContratosComponent,
    CriarContratoComponent,
    AtualizarContratoComponent,
    DialogComponent,
    DialogContratoComponent,
    PesquisaComponent,
    PesquisaCadastrarComponent,
    DialogEscolherGrupoComponent,
    AgrupamentosComponent,
    CriarAgrupamentosComponent,
    ListaUsuariosComponent,
    ListaClientesComponent,
    AtualizarAgrupamentoComponent,
    LicencaComponent,
    CadastrarLicencaComponent,
    AdquirirLicencaComponent,
    AlterarLicencaAdquiridaComponent,
    EscolherUsuarioEnviarTokenComponent,
    DialogAcessosPremocenterComponent,
    AgviewsConnectComponent,
    AgviewsConnectAtualizarComponent,
    SsoCallbackComponent,
    ShapesComponent,
    CadastrarShapeComponent,
    MiniMapaGeojsonComponent,
    SelectBuscaClienteComponent,
    MapaShapeDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    // MatDividerModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    FormsModule,
    MatInputModule,
    NgxPaginationModule,
    NgxMaskModule.forRoot(),
    MatDialogModule,
    MatSlideToggleModule,
    CommonModule,
    MatDividerModule,
    MatSelectModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatBadgeModule, 
    MatAutocompleteModule,
    MatTabsModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    httpInterceptorsProviders,
    CookieService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

